enum ResourceDataDiscriminator {
    Space = 'Space',
    Object = 'Object',
    Person = 'Person',
}

export default ResourceDataDiscriminator;
